import React, { useState, KeyboardEvent, useEffect } from 'react';
import { Edge } from 'reactflow';
import Icon from '../../forms/icon.component';
import Input from '../../forms/input.component';
import InvalidFeedback from '../../forms/invalid-feedback.component';
import { AlertService } from '../../../services/alert.service';

interface EdgeKeywordsFormProps {
  edge: Edge & { data: { keywords: string[] } };
  onAddEdgeKeyword: (edgeId: string, keyword: string) => void;
  onRemoveEdgeKeyword: (edgeId: string, keyword: string) => void;
}

const EdgeKeywordsForm: React.FC<EdgeKeywordsFormProps> = ({
  edge,
  onAddEdgeKeyword,
  onRemoveEdgeKeyword
}) => {
  const [tempKw, setTempKw] = useState('');
  const [error, setError] = useState<string | null>(null);
  const { id: edgeId, sourceHandle } = edge;
  const keywords = edge.data.keywords || [];

  useEffect(() => {
    if (error) setError(null);
  }, [tempKw]);

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if ((e.key === 'Enter' || e.key === ',') && tempKw.trim()) {
      e.preventDefault();
      const newKw = tempKw.trim();
      if (keywords.includes(newKw)) {
        AlertService.toastError('Ya existe esa palabra');
      } else {
        onAddEdgeKeyword(edgeId, newKw);
      }
      setTempKw('');
    }
  };

  return (
    <div>
      <label className="form-label">Palabras clave</label>
      <div className="px-2 mb-2">
        <span className="badge badge-light-info d-flex align-items-center">
          <Icon icon="ki-information-3" size="fs-1x ms-2" type="info" />
          <span className="ms-2">Presiona Enter o coma para agregar</span>
        </span>
      </div>
      <Input
        type="text"
        value={tempKw}
        placeholder="Escribe una palabra"
        onChange={(e: any) => setTempKw(e.target.value)}
        onKeyDown={handleKeyDown}
        className="form-control form-control-solid mb-2"
      />
      <InvalidFeedback error={error} />
      <div className="response-input-container mb-3">
        <div className="d-flex flex-wrap gap-2">
          {keywords.map((kw: any) => (
            <div key={kw} className="badge badge-light-primary d-flex align-items-center px-2 py-1">
              <span>{kw}</span>
              {kw !== sourceHandle && (
                <div
                  className="ms-2 cursor-pointer"
                  onClick={() => onRemoveEdgeKeyword(edgeId, kw)}
                >
                  <Icon icon="ki-cross-circle" type="danger" size="fs-1x" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EdgeKeywordsForm;
